import { TextField, Typography } from "@mui/material";

type Props = {
  position: number;
  color: string;
  onColorChange: (value: string) => void;
  disabled?: boolean;
};

export default function StopValueFields({
  position,
  color,
  onColorChange,
  disabled,
}: Props) {
  return (
    <>
      <Typography variant="body2" sx={{ width: 24, textAlign: "right" }}>
        {position}.
      </Typography>
      <TextField
        size="small"
        type="color"
        value={color}
        onChange={(event) => onColorChange(event.target.value)}
        disabled={disabled}
        fullWidth
      />
    </>
  );
}
